export const DAILY_CHECK_IN_MEMBER_PROGRESS = "DAILY_CHECK_IN_MEMBER_PROGRESS";
export const DAILY_CHECK_IN_CHECK_IN = "DAILY_CHECK_IN_CHECK_IN";
export const DAILY_CHECK_IN_CLEAR_PROGRESS = "DAILY_CHECK_IN_CLEAR_PROGRESS";